import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteManners, getMannersList, } from '../../actions/directoryBasicEducation'
import { deleteVariant, getApplicantQuestionSet, getApplicantQuestionSetById } from '../../actions/applicantQuestionSet'
import { GET_APPLICANT_QUESTION_SET_BY_ID } from '../../actions/types'


export default function ApplicantQuestionSet() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { applicantQuestionSetList, variant } = useSelector(state => state.applicantQuestionSet)


  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getApplicantQuestionSet())
  }, [])

  useEffect(() => {
    selectedItem && selectedItem.id && dispatch(getApplicantQuestionSetById(selectedItem.id))
  }, [selectedItem])

  const openModal = (data) => () => {
    setSelectedItem(data)
  }

  const closeModal = () => {
    setSelectedItem(null)
    dispatch({ type: GET_APPLICANT_QUESTION_SET_BY_ID, payload: [] });
  }

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteVariant(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { id, applicant, exam_date, test_time, level, school_year, task_amount, number, applicant_xp_key } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{school_year}</td>
        <td onClick={openModal(data)}>{level}</td>
        <td onClick={openModal(data)}>{number}</td>
        <td onClick={openModal(data)}>{applicant}</td>
        <td onClick={openModal(data)}>{exam_date}</td>
        <td onClick={openModal(data)}>{applicant_xp_key}</td>
        <td onClick={openModal(data)}>{task_amount}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id, name: level })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '1200px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={variant || selectedItem}
          height={'430px'}
          addMode={!selectedItem?.id}
        />
      }
      <h1>Варианты экзаменационных заданий</h1>
      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>Уч. год</th>
            <th>Класс</th>
            <th>№</th>
            <th>Претендент</th>
            <th>Дата тестирования</th>
            <th>Сформирован</th>
            <th>Кол-во заданий</th>
            <th></th>
          </tr>
        </thead>
        <tbody>

          {applicantQuestionSetList?.map(renderLi)}

        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal('add')}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}
